<template>
  <v-container>
    <h1>Cambiar contraseña</h1>
    <v-form ref="form" v-model="formValido">
      <v-card elevation="5" class="mx-auto">
        <v-card-text>
          <v-text-field
            v-model="passwordActual"
            :append-icon="mostrarPasswordActual ? 'mdi-eye' : 'mdi-eye-off'"
            :type="mostrarPasswordActual ? 'text' : 'password'"
            name="input-10-1"
            label="Contraseña actual"
            hint="Por lo menos 8 caracteres"
            counter
            @click:append="mostrarPasswordActual = !mostrarPasswordActual"
          ></v-text-field>
          <v-text-field
            v-model="nuevaPassword"
            :append-icon="mostrarNueva ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required, rules.min]"
            :type="mostrarNueva ? 'text' : 'password'"
            name="input-10-1"
            label="Contraseña nueva"
            hint="Por lo menos 8 caracteres"
            counter
            @click:append="mostrarNueva = !mostrarNueva"
          ></v-text-field>
          <v-text-field
            v-model="repitePassword"
            :append-icon="mostrarRepetida ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required, rules.min]"
            :type="mostrarRepetida ? 'text' : 'password'"
            name="input-10-1"
            label="Repite la nueva contraseña"
            hint="Por lo menos 8 caracteres"
            counter
            @click:append="mostrarRepetida = !mostrarRepetida"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          
          <v-spacer></v-spacer>

          <v-btn color="primary" text @click="cambiar" :disabled="!formValido">
            Registrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <v-snackbar
      v-model="mostrarMensaje"
      :timeout="3000"
      :color="mensaje.color"
      top
    >
      {{ mensaje.texto }}
    </v-snackbar>
  </v-container>
</template>
<script>
import HttpService from "../../Servicios/HttpService";
export default {
  name: "CambiarPassword",

  data: () => ({
    mostrarMensaje: false,
    mensaje: {
      texto: "",
      color: "",
    },
    formValido: false,
    mostrarPasswordActual: false,
    mostrarNueva: false,
    mostrarRepetida: false,
    passwordActual: "",
    nuevaPassword: "",
    repitePassword: "",
    rules: {
      required: (value) => !!value || "Debes colocar este dato.",
      min: (v) => v.length >= 8 || "Mínimo 8 caracteres",
    },
  }),

  methods: {
    async cambiar() {
  
  const coinciden = await this.verificarPasswordActual();
  
  if (!coinciden) {
    this.mensaje = { texto: "La contraseña actual es incorrecta", color: "error" };
    this.mostrarMensaje = true;
    return;
  }

  if (this.nuevaPassword !== this.repitePassword) {
    this.mensaje = { texto: "Las contraseñas nuevas no coinciden", color: "error" };
    this.mostrarMensaje = true;
    return;
  }

 
  const fd = new FormData();
  fd.append("metodo", "cambiar_pass");
  fd.append("idUsuario", localStorage.getItem("idUsuario"));
  fd.append("idSolicitante", localStorage.getItem("idUsuario"));
  fd.append("password", this.nuevaPassword);

  HttpService.registrar(fd, "usuarios.php").then((resultado) => {
    if (resultado && !resultado.error) {
      this.mensaje = { texto: "Contraseña actualizada con éxito", color: "success" };
      this.mostrarMensaje = true;
      
   
      setTimeout(() => {
        localStorage.clear();
        window.location.reload();
      }, 2000);
    }
  });
},

async verificarPasswordActual() {
 
  let payload = {
    metodo: "verifica_pass",
    password: this.passwordActual,
    id: localStorage.getItem("idUsuario"),
  };
  return await HttpService.obtenerConDatos(payload, "usuarios.php");
}
  },
};

</script>


// WEBPACK FOOTER //
// src/components/Usuarios/CambiarPassword.vue